// forms
// route page
import { HttpClient } from '@angular/common/http';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { LoginUser } from 'src/app/models/login-user';
import { UserService } from '../../services/user.service';
import { ApiResponse } from 'src/app/models/api-response';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppConfigService } from '../../app-config.service.service';
import { DataService } from '../../shared/data-service/data.service.service';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('uploader', { static: true })
  uploader: any;
  optionCompanysSelect: Array<any>;
  cardForm: FormGroup;
  submitted = false;
  isLoading = false;
  msgError: string;
  showError = false;
  file: File | null;
  apiBaseUrl: string;
  showPassword = false;
  typeInputPassword = 'password';
  settings: string;

  // openPopupImportService:boolean=false

  @Input() showLoginModal: boolean;

  @Output() result = new EventEmitter();
  
  dumLoginUser: LoginUser;

  constructor(private formBuilder: FormBuilder, private router: Router, private http: HttpClient,
    private userService: UserService, private data: DataService, private appConfigService: AppConfigService, private activatedRoute: ActivatedRoute, 
    public settingsCompany: CompanySettingsService,
    public apiConfig: AppConfigService,
    private route: ActivatedRoute) {

    // this.route.queryParams.subscribe(params => {
    //   console.log(params);
    // });

    this.settings = localStorage.getItem('settings');

    if (!this.settings || this.settings == 'null')
      this.settings = null;
    // validations
    // this.cardForm = fb.group({
    //   materialFormCardNameEx: ['', Validators.required],
    //   materialFormCardEmailEx: ['', [Validators.email, Validators.required]],
    //   materialFormCardConfirmEx: ['', Validators.required],
    //   materialFormCardPasswordEx: ['', Validators.required]
    // });
  }

  // onFileAdd(file: any) {
  //   this.file = file;
  // }
  //
  // onFileRemove() {
  //   this.file = null;
  // }
  //
  // uploadFile() {
  //   if (this.file) {
  //     const data = new FormData();
  //     data.append('file', this.file, this.file.name);
  //     const url = 'http://localhost:3000/api/upload/';
  //
  //     this.http.post(url, data, { responseType: 'text' }).subscribe( val => console.log(val));
  //   }
  // }
  ngOnInit() {

    // console.log('Url Id: ', this.activatedRoute.snapshot.queryParamMap.get("b"));

    var autoStart = localStorage.getItem('autoStart');

    if (autoStart != undefined) {

      var tmpEmail = localStorage.getItem('email');

      this.userService.autologin(tmpEmail).subscribe((data: ApiResponse) => {
        if (data.connected) {
          localStorage.clear();

          if (this.settings)
            console.log('Esto es settings ',this.settings);

          localStorage.setItem('termaccepted', data.termAccepted.toString());
          localStorage.setItem('token', data.token);
          localStorage.setItem('userName', data.userName);
          localStorage.setItem('isClient', data.isClient);
          localStorage.setItem('customerid', data.customerID);
          localStorage.setItem('email', tmpEmail);
          localStorage.setItem('currentLat', data.lat);
          localStorage.setItem('currentLong', data.long);
          localStorage.setItem('ubicacion', data.ubicacion);
          this.userService.currentUserName.next(data.userName);
          this.userService.isClient.next(JSON.parse(data.isClient.toLocaleLowerCase()));

          this.data.changeUser(data.userName);
          if (data.customerID) {
            this.userService.Get_UserSettingsCE(data.customerID).subscribe(result => {
              console.log('Gett user setting', result);

              if (result.length > 0 && result[0].CLIENTUSERSETTING) {
                let obj = JSON.parse(result[0].CLIENTUSERSETTING);
                console.log(this.apiConfig.moneyFormat);
                localStorage.setItem('settings', result[0].CLIENTUSERSETTING);
                localStorage.setItem('UserCompanyName', result[0].UserCompanyName);


                // This code detect boostrap screen standar resolution. Its used to start always
                // with home page if its mobile screen *************************
                const width = Math.max(
                  document.documentElement.clientWidth,
                  window.innerWidth || 0
                )
                var screenType = 'xl';
                if (width <= 576) { screenType = 'xs' }
                if (width <= 768) { screenType = 'sm' }
                if (width <= 992) { screenType = 'md' }
                if (width <= 1200) { screenType = 'lg' }
                var ignoreStartPage = false;
                if (screenType == 'xs' || screenType == 'sm') { ignoreStartPage = true }


                this.userService.settings.next(obj);


                let goto = obj.startPage && !ignoreStartPage ? obj.startPage : '/home';
                this.router.navigateByUrl(goto);
              } else {
                this.router.navigateByUrl('/home');
              }
            }, err => {
              console.log(err);
              this.router.navigateByUrl('/home')
            }
            );
          }

          this.data.clearMenu();

          // this.router.navigateByUrl('/home');
        } else {
          this.showError = true;
          this.msgError = 'Invalid User name or password';
        }
      }, error => {
        this.showError = true;
        this.msgError = 'Server internal error, please contact the administrator!';
      });

    }

    sessionStorage.clear();
    localStorage.clear();


    this.cardForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });

    this.apiBaseUrl = this.appConfigService.apiBaseUrl;

    console.log(this.apiBaseUrl);

    this.optionCompanysSelect = [
      { value: '1', label: 'Amazing Control' },
      { value: '2', label: 'CUBE-USA' },
      { value: '3', label: 'South Florida Control' },
      { value: '4', label: 'Template Company' },
      { value: '5', label: 'Travis Brothers' },
    ];

  }

  public resolved(captchaResponse: string): void {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  public onError(errorDetails): void {
    console.log(`reCAPTCHA error encountered; details:`, errorDetails);
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.typeInputPassword = this.showPassword ? 'text' : 'password';
  }
  onSubmit() {

    // this.router.navigateByUrl('/productsCart');
    // window.reload()

    // localStorage.setItem('token', "sdfsdf78d96f8s");
    // location.reload()
    // return 0;

    this.showError = false;
    this.msgError = '';
    this.submitted = true;
    // stop here if form is invalid
    if (this.cardForm.invalid) {
      return;
    }
    this.isLoading = true;
    let value = this.cardForm.value;
    let dataLogin = {
      "UserName": value.username,
      "Password": value.password,
      "client": "1"
    }
    this.userService.loginEcommerce(dataLogin).subscribe((data) => {
      console.log(data)
      if (data.connected) {
        localStorage.clear();

        if (this.settings)
          localStorage.setItem('settings', this.settings);
        localStorage.setItem('termaccepted', data.termAccepted.toString());
        localStorage.setItem('token', data.token);
        localStorage.setItem('userName', data.userName);
        localStorage.setItem('isClient', data.isClient);
        localStorage.setItem('customerid', data.customerID);
        localStorage.setItem('email', value.username);
        localStorage.setItem('currentLat', data.lat);
        localStorage.setItem('currentLong', data.long);
        localStorage.setItem('ubicacion', data.ubicacion);
        this.userService.currentUserName.next(data.userName);
        // this.userService.isClient.next(JSON.parse(data.isClient.toLocaleLowerCase()));

        this.data.changeUser(data.userName);
        location.reload()
        // if (data.customerID) {
        //   this.userService.Get_UserSettingsCE(data.customerID).subscribe(result => {
        //     console.log('Gett user setting', result);

        //     if (result.length > 0 && result[0].CLIENTUSERSETTING) {
        //       let obj = JSON.parse(result[0].CLIENTUSERSETTING);

        //       localStorage.setItem('settings', result[0].CLIENTUSERSETTING);
        //       localStorage.setItem('UserCompanyName', result[0].UserCompanyName);

        //       // This code detect boostrap screen standar resolution. Its used to start always
        //       // with home page if its mobile screen *************************
        //       const width = Math.max(
        //         document.documentElement.clientWidth,
        //         window.innerWidth || 0
        //       )
        //       var screenType = 'xl';
        //       if (width <= 576) { screenType = 'xs' }
        //       if (width <= 768) { screenType = 'sm' }
        //       if (width <= 992) { screenType = 'md' }
        //       if (width <= 1200) { screenType = 'lg' }
        //       var ignoreStartPage = false;
        //       if (screenType == 'xs' || screenType == 'sm') { ignoreStartPage = true }


        //       this.userService.settings.next(obj);

        //       this.userService.settings.next(obj);

        //       let goto = obj.startPage && !ignoreStartPage ? obj.startPage : '/home';
        //       // this.router.navigateByUrl(goto); esto funciona en caso de que el usuario tenga alguna ruta por defecto
        //       // this.router.navigateByUrl('/productsCart');
        //       location.reload()
        //     } else {
        //       // this.router.navigateByUrl('/productsCart');
        //       location.reload()
        //     }
        //   }, err => {
        //     console.log(err);
        //     // this.router.navigateByUrl('/productsCart');
        //   }
        //   );
        // }

        this.data.clearMenu();

        // this.router.navigateByUrl('/home');
      } else {
        this.showError = true;
        this.msgError = 'Invalid User name or password';
      }
    }, error => {
      this.showError = true;
      this.msgError = 'Server internal error, please contact the administrator!';
    });
    this.submitted = false;
    this.isLoading = false;
  }
  gotoEstimate() {
    console.log(this.cardForm);
  }
  public myDatePickerOptions: IMyOptions = {
    // Your options
  }

}
